var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.296875,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.982 137.928L228.777 170.324L299.155 138.674L205.087 102.031L140.982 137.928Z",
    fill: "#300901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.843 131.141L244.909 163.169L300.475 138.473L209.409 106.445L153.843 131.141Z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.512 115.054L244.777 143.984L289.229 124.16L208.965 95.2305L164.512 115.054Z",
    fill: "#373943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.023 100.013L289.288 128.942L289.287 120.71L209.022 91.7812L209.023 100.013Z",
    fill: "#4A4D5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.015 99.9952L164.617 119.8L164.617 111.586L209.015 91.7812L209.015 99.9952Z",
    fill: "#202129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.015 99.9952L207.023 100.886L202.722 94.5801L209.015 91.7812L209.015 99.9952Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.015 99.9952L284.62 127.309V118.918L209.015 91.7812L209.015 99.9952Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.014 99.9961L280.496 125.769L277.7 126.773L207.026 100.889L209.014 99.9961Z",
    fill: "#21232C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.909 144.646L153.843 112.618L209.409 87.9219L300.475 119.95L244.909 144.646ZM244.835 140.533L164.57 111.604L209.023 91.7802L289.288 120.709L244.835 140.533Z",
    fill: "#FFD6CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.909 144.646L153.843 112.618L209.409 87.9219L300.475 119.95L244.909 144.646ZM244.835 140.533L164.57 111.604L209.023 91.7802L289.288 120.709L244.835 140.533Z",
    fill: "url(#paint0_linear_569_27180)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.843 112.621L244.909 144.643V163.171L153.843 131.143V112.621Z",
    fill: "#6A2213"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M300.475 119.949L244.909 144.644V163.167L300.475 138.471V119.949Z",
    fill: "#F7785C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.305 106.932L258.731 131.095L263.008 128.858L197.451 105.387L194.305 106.932Z",
    fill: "#21232C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.059 103.793L260.571 127.552L260.571 129.827L196.059 106.067L196.059 103.793Z",
    fill: "#6A68C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.059 103.791L260.571 127.55L263.152 126.205L198.64 102.445L196.059 103.791Z",
    fill: "#B8B7F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.646 119.611L260.569 127.268L263.15 125.922L242.227 118.266L239.646 119.611Z",
    fill: "#6E6BE2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.825 121.938L256.27 125.475L257.716 124.724L248.271 121.188L246.825 121.938Z",
    fill: "#1C4664"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.053 126.863L259.821 126.337L261.268 125.586L261.563 126.023L260.053 126.863Z",
    fill: "#4745A9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M247.112 121.617L259.824 126.336L260.054 126.865L256.169 125.429L255.956 125.159L246.824 121.747L247.112 121.617Z",
    fill: "#6A68C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.11 121.618L259.822 126.337L261.268 125.586L248.556 120.867L247.11 121.618Z",
    fill: "#B8B7F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.107 121.618L246.836 121.742L248.283 120.991L248.554 120.867L247.107 121.618Z",
    fill: "#32688E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.57 130.163L260.569 127.267L263.15 125.922L263.151 128.818L260.57 130.163Z",
    fill: "#333180"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.646 119.609L260.578 127.288V130.185L239.646 122.464V119.609Z",
    fill: "#4745A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M282.004 128.142L282.004 123.881L290.337 120.238L299.158 120.588L282.004 128.142Z",
    fill: "#AE442E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.872 140.521L281.986 128.118L300.535 119.941L300.476 138.471L295.872 140.521Z",
    fill: "#300901"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M202.067 87.354L282.332 116.283L325.052 114.769L244.787 85.8398L202.067 87.354Z",
    fill: "#FFDBD3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M202.067 87.354L282.332 116.283L325.052 114.769L244.787 85.8398L202.067 87.354Z",
    fill: "url(#paint1_linear_569_27180)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M282.331 122.984V116.28L325.051 114.766L325.052 120.655L282.331 122.984Z",
    fill: "#F7785C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M282.343 123.005V116.301L202.068 87.3555L202.07 93.2449L282.343 123.005Z",
    fill: "#6A2213"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27180",
    x1: 267.364,
    y1: 104.869,
    x2: 257.278,
    y2: 131.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D1A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27180",
    x1: 270.678,
    y1: 89.7419,
    x2: 262.465,
    y2: 110.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE442E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7785C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary02);
export default __webpack_public_path__ + "static/media/library_02.b66f26a2a029714ede6f77d86d52f4da.svg";
export { ForwardRef as ReactComponent };